import PropTypes from 'prop-types';
import { Waypoint } from 'react-waypoint';
import { ModalNoResults } from '~/components/RecentContentFiltersBar';
import Spinner from '~/components/Spinner';
import { TiktokPreviewCard } from '~/components/TiktokPreviewCard';

import { SelectContentGrid } from '../SelectContentGrid';

/* This is the Modal from new MP
 *
 * TODO: It is necessary to refactor this part and
 * change to typescript all Select for the all Social Media
 * and the components related with this part.
 */

export const SelectTiktokComponent = ({
  content = [],
  disabledItemIds,
  isFetching,
  hasMore,
  maxItems,
  onItemClick,
  onLoadMore,
  selectedItemIds = [],
  status,
}) => {
  return (
    <>
      <SelectContentGrid
        columns={{ base: 3, md: 5, lg: 6 }}
        disabledItems={disabledItemIds}
        isDisabled={selectedItemIds.length === maxItems}
        max={maxItems}
        selectedItems={selectedItemIds}
      >
        {content.map((item) => (
          <SelectContentGrid.Item
            overflow="hidden"
            borderRadius="lg"
            id={item.id}
            key={item.id}
            onClick={onItemClick}
          >
            <TiktokPreviewCard item={item} borderRadius="lg" />
          </SelectContentGrid.Item>
        ))}
      </SelectContentGrid>

      {(status === 'loading' || isFetching) && <Spinner centered />}

      {status === 'success' && !content.length && (
        <ModalNoResults message={null} />
      )}

      {hasMore && (
        <Waypoint
          bottomOffset={-10}
          key={hasMore}
          onEnter={() => onLoadMore()}
        />
      )}
    </>
  );
};

SelectTiktokComponent.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object),
  disabledItemIds: PropTypes.arrayOf(PropTypes.string),
  hasMore: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  maxItems: PropTypes.number,
  onItemClick: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  selectedItemIds: PropTypes.arrayOf(PropTypes.string),
  status: PropTypes.string.isRequired,
};
